import React, { useState } from "react"
import styled from "styled-components"
import Image from "next/image"
import { themeGet } from "@styled-system/theme-get"
import SearchIcon2 from "@/common/assets/image/Icon/search-icon2.svg"

export default function Search({ search, onFocus = () => {} }) {
  const [searchText, setSearchText] = useState("")
  const [searchToggle, setSearchToggle] = useState(false)
  const handleChange = e => {
    const value = e.target.value
    setSearchText(value)
    search(value)
  }

  return (
    <Wrapper className={searchToggle === true ? "active" : ""}>
      <div
        action=""
        className="searchForm"
        style={{ display: "flex", alignItems: "center" }}
      >
        <input
          type="text"
          placeholder="Search"
          onChange={handleChange}
          value={searchText}
          onFocus={onFocus}
        />
        <ImageWrapper
          className="searchBtn"
          onClick={() => {
            setSearchToggle(!searchToggle)
          }}
        >
          <StyledImage src={SearchIcon2} alt="search" />
        </ImageWrapper>
      </div>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  width: 60px;
  height: 60px;
  overflow: hidden;
  justify-content: flex-end;
  padding: 15px;
  transition: 0.8s;
  border-bottom: 1px solid ${themeGet("colors.primary")}00;
  @media (max-width: 1024px) {
    width: 300px;
  }
  @media (max-width: 768px) {
    width: 100% !important;
    border: 0.5px solid ${themeGet("colors.primary")};
    border-radius: 50px;
    flex: 1;
    padding: 4px 12px;
  }

  .searchForm {
    display: flex;
    width: 100%;
    justify-content: flex-end;
    padding-left: 32px;
  }
  input {
    background-color: rgba(0, 0, 0, 0);
    width: 100%;
    height: unset !important;
    border: none;
    font-weight: 700;
    font-size: 1rem;
    color: #ffffff; // Ensure text is white
    ::placeholder {
      color: #ffffff;
      font-weight: 300;
    }
    &:focus {
      outline: none;
      color: black;
    }
  }

  &.active {
    width: 300px;
    border-bottom: 1px solid ${themeGet("colors.primary")};
    .searchBtn {
      > span {
        &:nth-child(1) {
          opacity: 0 !important;
        }
      }
    }
  }
`

const ImageWrapper = styled.div`
  flex: 0 0 30px;
  width: 30px;
  height: 30px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  > span {
    transition: 0.3s;
    &:nth-child(2) {
      position: absolute;
      top: 0;
      left: 0;
      z-index: -1;
    }
  }
`

const StyledImage = styled(Image)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  object-fit: contain;
`
